import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditDetailStuTestHistoryComp from "./Component/EditDetailStuTestHistoryComp"


const EditDetailStuTestHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditDetailStuTestHistoryComp />
        </div>
        <Footer />
        </>
    )
}

export default EditDetailStuTestHistory